

















import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { CommonComponentsAccessibleMixin } from "../../mixins";
import { EditingDocument } from "../..";
import { AlertList } from ".";

@Component({
  components: {
    AlertList,
  }
})
export default class AlertTool extends Mixins(ModelEditableMixin, CommonComponentsAccessibleMixin) {
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;
  editingSource: EditingDocument;

  get shouldMarkAlerts(): boolean {
    return this.readPropertyOrDefault(s => s.shouldMarkAlerts, false);
  }

  set shouldMarkAlerts(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldMarkAlerts = value);
  }

  async validate(): Promise<void> {
    this.commonComponents.operators.validator.validate(false)
    .then(result => {
      const count = this.editingSource.alerts.length;
      if (result.isOk) {
        this.$success("確認結果", "登録可能です。(警告件数:" + count + ")");
      } else {
        this.$warn("確認結果", "登録できません。(警告件数:" + count + ")");
      }
    })
    .catch(e => {
      this.$warn("警告", "警告処理中にエラーが発生しました。", e);
    });
  }
}
